<template>

  <v-list>

    <v-list-item class="px-2">
      <v-list-item-avatar color="secondary">
        <v-img :src="require('#Components/assets/logo.png')"></v-img>
      </v-list-item-avatar>
      <v-list-item-title class="secondary--text" color="secondary">Keywords Picker</v-list-item-title>
    </v-list-item>

    <v-divider></v-divider>

    <template v-for="item in items">
      <MenuNode :item=item :key="item.icon"></MenuNode>
    </template>
  
  </v-list>

</template>

<script>
import MenuNode from "./MenuNode"

export default {

  name: 'Admin_Structure_Menu',

  props: {
    items: Array
  },


  components: {
    MenuNode
  }

}
</script>